import React, { useState } from "react";
import Modal from "components/common/Modal/Modal";
import { TenantService } from "services/tenant";
import UnitTile from "components/features/Unit-Tile/Unit-Tile";
import AddUnitForm from "components/features/Add-Unit-Form/Add-Unit-Form";
import { UnitService } from "services/unit";
import AddEditTenantForm from "components/features/Add-Edit-Tenant-Form/Add-Edit-Tenant-Form";
import { formatDate } from "ultils/date-formatter";

interface UnitsProps {
  units?: any;
  propertyDetails: any;
  tenantList: any;
  onUnitsUpdated: (updatedDetails: any) => void; // Callback for parent to handle updates
}

const Units: React.FC<UnitsProps> = ({
  units,
  onUnitsUpdated,
  propertyDetails,
  tenantList,
}) => {
  const [selectedUnit, setSelectedUnit] = useState<any>(null);
  const [unitList] = useState<any>(units ?? []);
  const [title, setTitle] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedTenant, setSelectedTenant] = useState<any>(null);
  const [tenantTitle, setTenantTitle] = useState<any>(null);
  const [isTenantModalOpen, setIsTenantModalOpen] = useState(false);
  const [isSelectTenantModalOpen, setIsSelectTenantModalOpen] = useState(false);

  const openModal = () => {
    setSelectedUnit(null);
    setTitle("Add Unit");
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);
  const closeTenantModal = () => setIsTenantModalOpen(false);
  const closeSelectTenantModal = () => setIsSelectTenantModalOpen(false);

  const openEditModal = (selectedRecord: any) => {
    setSelectedUnit(selectedRecord);
    setTitle("Edit Unit");
    setIsModalOpen(true);
  };

  const addTenantModal = (unit: any) => {
    setSelectedUnit(unit);
    setSelectedTenant(null);
    setTenantTitle("Add Tenant to Unit " + unit.name);
    setIsTenantModalOpen(true);
  };

  const editTenantModal = (unit: any) => {
    setSelectedTenant(unit.tenants[0]);
    setTenantTitle("Edit Tenant on Unit " + unit.name);
    setIsTenantModalOpen(true);
  };

  const selectTenantModal = (unit: any) => {
    setSelectedUnit(unit);
    setTenantTitle("Select Tenant on Unit " + unit.name);
    setIsSelectTenantModalOpen(true);
  };

  const onUnitUpdate = async (
    unit: any,
    e: React.FormEvent,
    editMode: boolean
  ) => {
    console.log("call unit service and post", unit);

    if (!editMode) await UnitService.postUnit(unit);
    else await UnitService.updateUnit(unit);

    closeModal();
    onUnitsUpdated(e);
  };

  const onTenantUpdate = async (
    tenantDetailsForm: any,
    e: React.FormEvent,
    editMode: boolean
  ) => {
    if (selectedUnit) {
      tenantDetailsForm.unitId = selectedUnit.unitId;
      tenantDetailsForm.propertyId = selectedUnit.propertyId;
    }
    if (editMode === false) await TenantService.postTenant(tenantDetailsForm);
    else await TenantService.updateTenant(tenantDetailsForm);

    closeTenantModal();
    onUnitsUpdated(e);
  };

  const findActiveTenant = async (tenantList: any, unit: any) => {
    unit.activeTenant = tenantList.find((t: any) => t.active === true) || null;
    return tenantList.find((t: any) => t.active === true) || null;
  };

  const setTenantToUnit = async (tenant: any) => {
    tenant.unitId = selectedUnit.unitId;
    console.log(tenant);
    console.log(selectedUnit);

    await TenantService.updateTenant(tenant);

    closeTenantModal();
    // onUnitsUpdated(e);
  };

  return (
    <div className="">
      <div className={"add-property-container"}>
        <div className="header-container">
          {" "}
          <h1>Units</h1>{" "}
          <button
            disabled={unitList.length >= propertyDetails.numOfUnits}
            className="btn"
            onClick={openModal}
          >
            Add Unit
          </button>
        </div>

        <div>
          {unitList.length > 0 ? (
            unitList.map((unit: any) => (
              <UnitTile
                key={unit.unitId}
                unit={unit}
                activeTenant={findActiveTenant(unit.tenants, unit)}
                openEditModal={openEditModal}
                addTenantClicked={addTenantModal}
                editTenantClicked={editTenantModal}
                selectTenantClicked={selectTenantModal}
              />
            ))
          ) : (
            <p>Add Units to get started</p>
          )}
        </div>

        <Modal title={title} isOpen={isModalOpen} onClose={closeModal}>
          <AddUnitForm
            propertyDetails={propertyDetails}
            onUnitUpdate={onUnitUpdate}
            unitDetails={selectedUnit}
          />
        </Modal>

        <Modal
          title={tenantTitle}
          isOpen={isTenantModalOpen}
          onClose={closeTenantModal}
        >
          <AddEditTenantForm
            propertyDetails={propertyDetails}
            onTenantUpdate={onTenantUpdate}
            unitDetails={selectedUnit}
            tenantDetails={selectedTenant}
          />
        </Modal>

        <Modal
          title={tenantTitle}
          isOpen={isSelectTenantModalOpen}
          onClose={closeSelectTenantModal}
        >
          <table style={{ border: 1, width: "100%", textAlign: "left" }}>
            <thead>
              <tr>
                <th>Active</th>
                <th>Full Name</th>
                <th>Unit Id</th>
                <th>Lease Start Date</th>
                <th>Lease End Date</th>
                <th>Date Added</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tenantList.length > 0 ? (
                tenantList.map((tenant: any) => (
                  <tr key={tenant.id}>
                    <td>{tenant.active ? "🟢" : "🔴"}</td>
                    <td>{`${tenant.firstName} ${tenant.lastName}`}</td>
                    <td>{tenant.unitId}</td>
                    <td>{formatDate(tenant.leaseStartDate, "MM/dd/yyyy")}</td>
                    <td>{formatDate(tenant.leaseEndDate, "MM/dd/yyyy")}</td>
                    <td>
                      {formatDate(tenant.dateAdded, "MM/dd/yyyy HH:mm a")}
                    </td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => setTenantToUnit(tenant)}
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6}>No tenants available</td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal>
      </div>
      {/* <TenantDetails  /> */}
    </div>
  );
};

export default Units;
